<xware-nav-main #nav>
  <!--pre-start-->
  <div *ngIf="bIsLoading" class="loading-center">
    <div id="loadingMessage" class="section-h2 center tracking-in-expand">Loading...</div>
    <div class="home-pg-loader cw-loader" style="margin-top: 30px">
      <div class="cw-loader-line"></div>
    </div>
  </div>

  <!--Error-->
  <div id="notAv" *ngIf="!cmsAvailable" class="centerdiv" style="margin-top: 130px">
    <div class="center" style="padding-bottom: 20px; color: var(--gr-color-550)">
      <i class="far fa-cloud fa-5x"></i>
    </div>
    <div class="center" style="margin-top: 10px">
      Crossware Mail Signature <span *ngIf="bInvalidID"> for Office 365 </span> is currently
      unavailable
    </div>
    <div *ngIf="!bInvalidID" class="center" style="margin-top: 10px">
      <a href="mailto:support@crossware365.com?subject=CMS%20Onboarding%20-%20Unavailable"
        >Try refreshing the page again or <br />
        contact support&#64;crossware365.com for help.</a
      >
    </div>
    <div *ngIf="bInvalidID" style="margin-top: 10px" class="center">
      <div class="section-h2">Invalid Account Type</div>
      <div>
        The Microsoft account you have logged into does not appear to include Exchange Online.
      </div>
      <div>Please try again with a different account or contact us for help.</div>
      <div class="center" style="margin-top: 10px">
        <a
          href="mailto:support@crossware365.com?subject=CMS%20Onboarding%20-%20Unavailable - Invalid ID"
        >
          Please contact support&#64;crossware365.com if you need help.</a
        >
      </div>
    </div>
  </div>

  <div *ngIf="!bIsLoading && cmsAvailable" class="grid-outer-container">
    <router-outlet></router-outlet>
  </div>
</xware-nav-main>
